import SignupRoot from '@/views/signup/SignupRoot';
import Name from '@/views/signup/SignupName';
import ContactDetails from '@/views/signup/SignupContactDetails';
import EnterOtp from '@/views/signup/SignupEnterOtp';

export default {
  path: '/signup',
  name: 'Signup',
  component: SignupRoot,
  children: [
    {
      path: 'name',
      name: 'SignupName',
      component: Name,
    },
    {
      path: 'contact',
      name: 'SignupContactDetails',
      component: ContactDetails,
    },
    {
      path: 'enter-otp',
      name: 'EnterOtp',
      component: EnterOtp,
    },
  ],
};
